import { z } from 'zod';
import { isoTimestamp, pageQuery, userRole, uuid } from './primitives.js';
export const user = z.object({
    id: uuid,
    email: z.email(),
    name: z.string(),
    role: userRole,
    is_active: z.boolean(),
    created_at: isoTimestamp,
    updated_at: isoTimestamp,
});
export const password = z
    .string()
    .min(12, 'Passwort muss mindestens 12 Zeichen lang sein')
    .max(256);
export const createUserBody = z.object({
    email: z.email(),
    name: z.string().min(1).max(120),
    role: userRole.default('operator'),
    password,
});
export const updateUserBody = z
    .object({
    email: z.email(),
    name: z.string().min(1).max(120),
    role: userRole,
    is_active: z.boolean(),
    password,
})
    .partial()
    .refine((v) => Object.keys(v).length > 0, { message: 'Mindestens ein Feld erforderlich' });
export const listUsersQuery = pageQuery.extend({
    is_active: z.stringbool().optional(),
});
/**
 * A browser session is short because a shared laptop is a real risk. The app
 * sits on a locked phone and is supposed to wake someone at night, so being
 * logged out twice a day would defeat the point.
 */
export const SESSION_CLIENTS = ['web', 'app'];
export const sessionClient = z.enum(SESSION_CLIENTS);
export const createSessionBody = z.object({
    email: z.email(),
    password: z.string().min(1).max(256),
    client: sessionClient.default('web'),
});
export const sessionResponse = z.object({
    user,
    expires_at: isoTimestamp,
});
//# sourceMappingURL=users.js.map